module.exports = __webpack_public_path__ + "static/media/icon_box_white.7c8da280.svg";